import cn from 'classnames';
import { useEffect, useRef, useState, type ComponentProps } from 'react';
import * as st from './styles.module.scss';

type ImageWithSkeletonPT = ComponentProps<'img'> & {
  wrapperClassName?: string;
};
export const ImageWithSkeleton = ({
  src,
  alt,
  className,
  wrapperClassName,
  ...props
}: ImageWithSkeletonPT) => {
  const [isLoading, setIsLoading] = useState(true);
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    if (imgRef.current?.complete) {
      setIsLoading(false);
    }
  }, []);

  return (
    <div className={cn(st.wrapper, wrapperClassName)}>
      {isLoading && (
        <div className={cn(st.skeleton, className)}>
          <div className={st.shimmer}></div>
        </div>
      )}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        onLoad={() => setIsLoading(false)}
        {...props}
        className={cn(st.image, !isLoading && st.imageVisible, className)}
      />
    </div>
  );
};
